import { serialize } from 'object-to-formdata';
import axios from 'axios';
import CryptoJS from "crypto-js";

export const fieldValuesCheck = (fileds, form) => {
  const checkValues = fileds.every((item) => form.getFieldValue(item));
  return checkValues;
};

const nameConversion = (value) => value.split('_').join(' ');
 
export const throwErrors = (data, form) => {
  data.forEach((item) => {
    if (!form.getFieldValue(item)) {
      form.setFields([
        {
          name: item,
          errors: [`${nameConversion(item)} is required`],
        },
      ]);
    }
  });
};

 const generateToken = async () => {
  return  CryptoJS.AES.encrypt(
     `${process.env.CAMPAIGN_VALUE}`,
     `${process.env.CAMPAIGN_SECRET}`
   ).toString();
}
export const bulkCustomersUpload = (object, files,apiUrl) => {
  const formData = serialize({ ...object, ...files });
  const token =generateToken()
  return axios({
    method: 'POST',
    url: `${apiUrl}customer-upload`,
    data: formData,
    headers: {
      // eslint-disable-next-line no-template-curly-in-string
      'Content-Type': 'multipart/form-data; boundary=${form._boundary}',
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getCustomerDownload = (apiUrl) => {
  const token =generateToken()
  return axios({
    method: 'get',
    url: `${apiUrl}customer-download`,
    responseType: 'blob',
    headers: {
      // eslint-disable-next-line no-template-curly-in-string
      'Content-Type': 'multipart/form-data; boundary=${form._boundary}',
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getApiUrl = async (data) => {
  const { apiUrl, filterName } = data;
  return apiUrl.split(',').filter((item) => {
    const findIndex = item.indexOf("v1");
    return item.startsWith(filterName, findIndex + 3);
  })
}

export const createUser =(payload,apiUrl)=>{
  return axios({
    method: 'POST',
    url: `${apiUrl}add-campaign-user`,
    data:payload,
    headers: {
      // eslint-disable-next-line no-template-curly-in-string
      'Content-Type': 'application/json',
      Authorization: `Bearer ${generateToken()}`,
    },
  });
}

export const getWalletBalance =(payload,apiUrl)=>{
  return axios({
    method: "POST",
    url: `${apiUrl}user-wallet`,
    data: payload,
    headers: {
      // eslint-disable-next-line no-template-curly-in-string
      'Content-Type': 'application/json',
      Authorization: `Bearer ${generateToken()}`,
    },
  }); 
}


